import { apiInvoker } from '../../lib/apiInvoker';
import { API_URLS } from '../../lib/apiUrls';
import { 
  fetchDashboardStart, 
  fetchDashboardSuccess, 
  fetchDashboardFailure,
} from '../slices/dashboardSlice';
import { handleApiError } from '../../utils/errorHandler';

export const fetchDashboardStats = (startDate, endDate, forceFetch = false) => {
  return async (dispatch, getState) => {
    const state = getState();
    const dashboardState = state.dashboard;
    const dateRange = `${startDate}_${endDate}`;
    
    if (!forceFetch && dashboardState.lastFetchedDateRange === dateRange) {
      return;
    }

    try {
      dispatch(fetchDashboardStart());
      const url = API_URLS.USER.USER_STATS(startDate, endDate);
      const response = await apiInvoker.get(url);
      
      if (response?.success && response?.data) {
        dispatch(fetchDashboardSuccess({
          data: response.data,
          dateRange: dateRange,
          startDate: startDate,
          endDate: endDate
        }));
      } else if (response && !response.success) {
        throw new Error(response?.message || 'Failed to fetch dashboard stats');
      } else if (response) {
        dispatch(fetchDashboardSuccess({
          data: response,
          dateRange: dateRange,
          startDate: startDate,
          endDate: endDate
        }));
      } else {
        throw new Error('Invalid response from server');
      }
    } catch (error) {
      console.error('Dashboard stats fetch error:', error);
      
      const { message: errorMessage } = handleApiError(error, {
        defaultMessage: 'Failed to fetch dashboard data',
        customMessages: {
          400: 'Validation failed. Please check the date format.',
        },
        skipToastForStatus: [401, 403],
      });
      
      dispatch(fetchDashboardFailure(errorMessage));
    }
  };
};

